import { render, staticRenderFns } from "./expandTextContent.vue?vue&type=template&id=9937685e"
import script from "./expandTextContent.vue?vue&type=script&lang=js"
export * from "./expandTextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports